const getFilterNameByType = type => ({
  size: 'Размер',
  category: 'Категория',
  series: 'Серия',
})[type];

export default getFilterNameByType;



// WEBPACK FOOTER //
// ./src/utils/getFilterNameByType.js